var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47 6.47a.75.75 0 011.06 0l4.647 4.646a1.25 1.25 0 010 1.768L10.53 17.53a.75.75 0 11-1.06-1.06L13.94 12 9.47 7.53a.75.75 0 010-1.06z",
    fill: "currentColor"
  })));
}
SvgChevronRight.displayName = 'ChevronRight';
export default SvgChevronRight;